<template>
	<v-dialog v-model="show" max-width="900" persistent>
		<v-card>
			<v-card-text>
				<v-layout row wrap>
					<v-flex xs12 class="mb-3">
						<span class="title">{{ $t('labels.contactEmailAddress') }}:</span>
						<span class="email-pill" v-for="(email, key) in emails" :key="key">
							<v-icon @click="removeEmail(key)" class="pill-remove-button" small>fa-trash</v-icon>
							{{email}}
						</span>
					</v-flex>
				</v-layout>
				<v-layout row wrap>
					<template v-if="templateLoaded">
						<v-flex xs12>
							<InputField v-model="subject"></InputField>
						</v-flex>
						<v-flex xs12>
							<Editor
								:init="$tinymceInit"
								v-model="body"></Editor>
						</v-flex>
					</template>
					<v-flex xs12>
						<UploadMultiple
							v-model="attachments"
							:showList="true"
							:label="$t('labels.uploadFiles')">
						</UploadMultiple>
					</v-flex>
				</v-layout>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn @click="reset">{{ $t('buttons.cancel') }}</v-btn>
				<v-btn @click="send">{{ $t('buttons.ok') }}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import UploadMultiple from "./trinkets/UploadMultiple";
import InputField from "./trinkets/InputField";
import Dropdown from "./trinkets/Dropdown";
import Editor from '@tinymce/tinymce-vue';

export default {
	name: "QuestionnaireEmailModal",
	props: ['show', 'contact', 'opportunities'],
	components: {
		InputField,
		Dropdown,
		Editor,
		UploadMultiple
	},
	data: function () {
		return {
			subject: '',
			body: '',
			templateLoaded: false,
			emails: [],
			attachments: []
		}
	},
	watch: {
		show: function () {
			this.template = null;
			if (this.show) {
				this.emails = [];
				this.attachments = [];
				if (this.contact.email != '' && this.contact.email != null) {
					this.emails.push(this.contact.email);
				}
				if (this.contact.otheremail != '' && this.contact.otheremail != null) {
					this.emails.push(this.contact.otheremail);
				}
				if (this.contact.secondaryemail != '' && this.contact.secondaryemail != null) {
					this.emails.push(this.contact.secondaryemail);
				}
				if (this.contact.additionalemail2 != '' && this.contact.additionalemail2 != null) {
					this.emails.push(this.contact.additionalemail2);
				}
				if (this.contact.additionalemail3 != '' && this.contact.additionalemail3 != null) {
					this.emails.push(this.contact.additionalemail3);
				}
				this.loadTemplate();
			} else {
				vm.subject = '';
				vm.body = '';
				vm.attachments = [];
				this.templateLoaded = false;
			}
		}
	},
	methods: {
		removeEmail(key) {
			this.emails.splice(key, 1);
		},
		loadTemplate() {
			let vm = this;
			this.$APICall('post', 'questionnaire-get-email-template', {
				contact: this.contact,
				opportunities: this.opportunities
			}, (data, success) => {
				if (success) {
					vm.subject = data.subject;
					vm.body = data.body;
					vm.$nextTick(() => {
						vm.templateLoaded = true;
					});
				}
			}, false);
		},
		reset() {
			let vm = this;
			this.$verify(this.$t('alerts.emailCancelQuestion'), (result) => {
				if (result) {
					vm.subject = '';
					vm.body = '';
					vm.attachments = [];
					vm.$emit('callback');
				}
			});
		},
		send() {
			let vm = this;
			if (this.emails.length > 0) {
				this.$verify(this.$t('alerts.emailSendQuestion'), (result) => {
					if (result) {
						let payLoad = {
							destinations: this.emails,
							subject: this.subject,
							body: this.body,
							attachments: this.attachments
						}
						this.$APICall('post', 'email', payLoad, (data, success) => {
							if (success) {
								if (data.message_id != '') {
									let messageId = data.message_id;
									let vtiger_ids = [];
									for (let opportunity of vm.opportunities) {
										vtiger_ids.push(opportunity.vtiger_id);
									}
									vm.$APICall('post', 'contacts/' + vm.contact.id + '/add-brochures', {new_brochures: vtiger_ids}, (data, success) => {
										vm.$VtigerCall('post', 'create-offer-task', {
											contact: vm.contact.vtiger_id,
											potentials: vtiger_ids
										}, (data, success) => {
											vm.$VtigerCall('post', 'new-email-contact', {
												message_id: messageId,
												contact: vm.contact.vtiger_id,
												body: vm.body,
												subject: vm.subject,
												to: vm.emails,
												attachments: vm.attachments
											}, (data, success) => {
												vm.$notify(this.$t('alerts.emailSent'));
												vm.$emit('callback');
											});
										});
									});
								} else {
									vm.$alert(data.error);
									vm.$emit('callback');
								}
							} else {
								vm.$alert(vm.$t('alerts.basicError'));
							}
						});
					}
				});
			} else {
				vm.$alert(vm.$t('alerts.noRecipients'));
			}
		},
	},
	mounted() {

	}
}
</script>

<style scoped>
	.email-pill {
		display: inline-block;
		color: #454545;
		border: 1px solid #b5b5b5;
		padding: 5px;
		margin-left: 3px;
		margin-right: 3px;
		border-radius: 8px;
	}
	.pill-remove-button {
		cursor: pointer;
	}
</style>
